<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('district.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('district.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-panel>
      <ts-panel-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
							v-tooltip="$t('district.search')"
              :placeholder="$t('district.search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-panel-wrapper>
      <ts-table
        :columns="columns"
        :records="districtResources"
        :loading="loading"
      >
        <template v-slot="{ record }">
          <td>{{ record.province_code }}</td>
          <td>{{ record.p_name_kh }}</td>
          <td>{{ record.p_name_en }}</td>
          <td class="ts-text-blue-500">{{ record.district_code }}</td>
          <td class="ts-text-blue-500">{{ record.name_kh }}</td>
          <td class="ts-text-blue-500">{{ record.name_en }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="districtPaginate"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-modal
      v-if="show_form"
      v-model="show_form"
      :title="!isUpdate ? $t('addNew') : $t('update')"
      :centered="true"
      @cancel="onCancel"
      :footer="null"
    >
      <DistrictForm :record="record" @cancel="onCancel" />
    </a-modal>
  </div>
</template>

<script>
import { debounce, isEmpty } from 'lodash'
import { mapState } from 'vuex'
import DistrictForm from './components/district-form.vue'
export default {
  name: 'branchIndex',
  components: {
    DistrictForm
  },
  data() {
    return {
      loading: false,
      show_form: false,
      record: {}
    }
  },
  computed: {
    ...mapState('corporate/address', ['districtResources', 'districtPaginate']),

    isUpdate() {
      return !isEmpty(this.record)
    },
    search: {
      get() {
        return this.$store.state.corporate.address.search
      },
      set(newValue) {
        this.$store.commit('corporate/address/SET_SEARCH', newValue)
        this.$store.commit('corporate/address/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('district.provinceCode') },
        { name: this.$t('district.provinceNameKh') },
        { name: this.$t('district.provinceNameEn') },
        { name: this.$t('district.districtCode') },
        { name: this.$t('district.nameKh') },
        { name: this.$t('district.nameEn') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('corporate/address/districtFetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.show_form = true
    },
    edit(record) {
      this.record = record
      this.show_form = true
    },
    onCancel() {
      this.show_form = false
      this.record = {}
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('corporate/address/RESET_STATE')
    next()
  }
}
</script>
